import { SEOHead } from "./SEOHead";

interface SEOProps {
  title: string;
  description: string;
  schema?: Record<string, any>[];
  canonical?: string;
  ogImage?: string;
  noIndex?: boolean;
}

export function SEO({
  title,
  description,
  schema,
  canonical,
  ogImage,
  noIndex,
}: SEOProps) {
  return (
    <SEOHead
      title={title}
      description={description}
      schemaJson={schema}
      canonical={canonical}
      ogImage={ogImage}
      noIndex={noIndex}
    />
  );
}
